"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
require("bootstrap");
require("slick-carousel");
var _sweetalert = require("sweetalert2/src/sweetalert2");
var _sweetalert2 = _interopRequireDefault(_sweetalert);
var _jsCookie = require("js-cookie");
var _jsCookie2 = _interopRequireDefault(_jsCookie);
require("./scss/frontend/style.scss");
require("./js/_section-sku-slider");
require("./js/_section-sku-banner-slider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.jQuery = _jquery2.default;
window.$ = _jquery2.default;
(0, _jquery2.default)(function () {
  (0, _jquery2.default)(document).on('click', '.inner-link', function () {
    (0, _jquery2.default)('.navbar-collapse').collapse('hide');
  });
});